'use strict';

var React = require('react');

var SvgMobileAcceptMajor = function SvgMobileAcceptMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"
  }));
};
SvgMobileAcceptMajor.displayName = "MobileAcceptMajor";

exports.SvgMobileAcceptMajor = SvgMobileAcceptMajor;
